import * as React from "react";
import classnames from "classnames";
import { QuickFilterButton } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { PreferredTimePopupModalContainer } from "../../../../PreferredTimePopupModal/v3/components/PreferredTimePopupModal/PreferredTimePopupModalContainer.js";
/* empty css                   */
const PreferredTime = ({
  className,
  labels,
  onClickPreferredTime,
  calendar,
  withPreferredTimeFilters = false,
  openPreferredTimePopup = false,
  onPreferredTimePopupClose,
  preferredTimeFilterItems,
  preferredTimeFilter,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("preferred-time", className) }, /* @__PURE__ */ React.createElement("div", { className: "preferred-time__title" }, /* @__PURE__ */ React.createElement(Heading, { component: "h4", variant: "subheading1", className: "preferred-time__title--heading" }, labels.title), withPreferredTimeFilters && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "preferred-time__button",
      onClick: onClickPreferredTime,
      "data-t": "quickFilter"
    },
    labels.preferredTime
  ))), withPreferredTimeFilters && /* @__PURE__ */ React.createElement(
    PreferredTimePopupModalContainer,
    {
      isOpen: openPreferredTimePopup,
      onModalClose: onPreferredTimePopupClose,
      items: preferredTimeFilterItems
    }
  ), preferredTimeFilter && /* @__PURE__ */ React.createElement("div", { className: "preferred-time__filters" }, /* @__PURE__ */ React.createElement(QuickFilterButton, { className: "preferred-time__filter", ...preferredTimeFilter })), calendar);
};
export {
  PreferredTime as default
};
//# sourceMappingURL=PreferredTime.js.map
